import React from "react";
import "./styles.css"
import click_sound from "./sounds/click.mp3";

class Atom extends React.Component {
    componentDidMount() {
        this.clickSound = new Audio(click_sound);
        this.clickSound.volume = 0.5;
    }
    callback = () => {
        this.props.callback(this.props.atom);
        this.clickSound.play();
    }

    is_activated() {
        let is_active = this.props.is_active(this.props.atom);
        //console.log("Atom " + this.props.atom + " is " + is_active);
        return is_active;
    }

    render() {
        return (
            <div className="AtomMain">
                <button className={this.is_activated() ? "AtomButtonActivated" : "AtomButton"} onClick={this.callback}>
                    <div className="AtomPart">
                        <h1 className="AtomLetters">{this.props.atom}</h1>
                        <h1 className="AtomName">{this.props.atomName}</h1>
                        <h1 className="AtomMass">{this.props.atomMass}</h1>
                    </div>
                    <div className="AtomPart">
                        <h1 className="AtomNumber">{this.props.atomNumber}</h1>
                    </div>
                </button>
            </div>
        )
    }
}

export default Atom